import { BiSortAlt2 } from 'react-icons/bi';
import { Button } from '@/components/ui/button';
import { toSpecialFixed } from '@/lib/misc/utils';
const DTKeypadHeader = ({
  token,
  usdAmount,
  isSwitched,
  setIsSwitched,
  tokenAmount,
  form
}) => {
  const handleNumberInput = (val: string) => {
    // Remove invalid characters (anything except digits and '.')
    val = val?.toString();
    val = val.replace(/[^0-9.]/g, '');

    // Preserve a standalone '.' or valid numbers
    if (val === '.') {
      return '0.'; // Converts "." to "0." for valid input
    }

    // Limit digits after the decimal to 3
    if (val?.includes('.')) {
      const parts = val.split('.');
      const integerPart = parts[0];
      let decimalPart = parts[1];
      const decimalLength = decimalPart.length;

      // Limit the decimal part to a maximum of 3 digits
      if (decimalLength > 3) {
        decimalPart = decimalPart.substring(0, 3);
      }
      // Reconstruct the value with the limited decimal part
      val = `${integerPart}.${decimalPart}`;
    }
    return val;
  };
  const calculatedAmount = isSwitched ? handleNumberInput(tokenAmount) : handleNumberInput(usdAmount);
  const displayCurrency = isSwitched ? token?.contract_ticker_symbol : 'USD';
  const handleNumPadUsdChange = (val: string) => {
    const tokenUsdAmount = val;
    const _usdToToken = parseFloat(val) / token.quote_rate;
    console.log('val usd......', {
      tokenUsdAmount,
      _usdToToken
    });
    form.setValue('tokenUsdAmount', tokenUsdAmount);
    form.setValue('tokenAmount', _usdToToken);
  };
  const handleNumPadTokenChange = (val: string) => {
    const tokenAmount = val;
    const _tokenToUsd = parseFloat(val) * token.quote_rate;
    console.log('val token......', {
      tokenAmount,
      _tokenToUsd
    });
    form.setValue('tokenAmount', tokenAmount);
    form.setValue('tokenUsdAmount', isNaN(Number(_tokenToUsd)) ? '0' : _tokenToUsd);
  };
  const handleClickNumPad = e => {
    const pad = handleNumberInput(e.target.value);
    isSwitched ? handleNumPadTokenChange(pad) : handleNumPadUsdChange(pad);
  };
  function centerAmount(calculatedAmount) {
    const length = calculatedAmount?.toString().length || 0;
    if (length === 2) {
      return 'text-[78px] -translate-x-[20px]';
    }
    if (length >= 8) {
      return 'text-[42px] -translate-x-[-70px]';
    }
    if (length >= 7) {
      return 'text-[52px] -translate-x-[-50px]';
    }
    if (length >= 5) {
      return 'text-[52px] -translate-x-[-50px]';
    }
    if (length >= 4) {
      return 'text-[52px] -translate-x-[0px]';
    }
    if (length >= 3) {
      return 'text-[52px] -translate-x-[10px]';
    }
    return 'text-[78px] -translate-x-[20px]'; // Default for no value or single-digit input
  }
  return <>
      <div className='w-full'>
        <div className='m-auto ta-c'>
          <div className='position relative'>
            <div className={` w-full justify-center items-center transition-all`}>
              <div className='flex flex-col justify-center items-center my-12 w-full'>
                <div className='w-full h-[80px] relative'>
                  <div className='text-genius-cream break-all w-full'>
                    <div className='w-full'>
                      <div className={`w-full justify-center items-center transition-all`}>
                        <div className={`absolute top-1/2 transform -translate-y-1/2
                                                     ${centerAmount(calculatedAmount)}`}>
                          <div className='flex justify-center w-full items-center'>
                            <input type='text' value={calculatedAmount} onChange={handleClickNumPad} className={`p-0 m-[0px] ta-r w-[40%] bg-transparent border-none focus:outline-none focus-visible:outline-none text-genius-cream transition-all`} placeholder='0' />
                            <span className='w-[50%] ta-l text-genius-cream/70 transition-all flex items-center whitespace-nowrap'>
                              {displayCurrency}
                              <Button variant='ghost' type='button' size='icon' className='bg-genius-blue rounded-full w-[25px] h-[25px] hover:bg-genius-blue transition-all ml-4' onClick={() => {
                              setIsSwitched(!isSwitched);
                            }} data-sentry-element="Button" data-sentry-source-file="DTKeypadHeader.tsx">
                                <BiSortAlt2 className='text-primary w-[10px] h-[10px]' data-sentry-element="BiSortAlt2" data-sentry-source-file="DTKeypadHeader.tsx" />
                              </Button>
                            </span>
                          </div>
                        </div>
                        <div className={`absolute top-1/2 w-full transform -translate-y-[-40px]
                                                      -translate-x-[0px]`}>
                          <div className='w-full grid justify-items-center text-[12px]'>
                            <div className='flex flex-nowrap justify-center items-center mt-4 gap-1'>
                              {!isSwitched ? <>
                                  <p className='opacity-40'>
                                    {toSpecialFixed(tokenAmount, 4).value}
                                  </p>
                                  <p className='opacity-40'>Of</p>
                                  <p>{token?.contract_ticker_symbol}</p>
                                </> : <p className='opacity-40'>{toSpecialFixed(usdAmount).value} USD</p>}
                            </div>
                            <div className='text-genius-cream/20 flex gap-1 mb-4'>
                              <p>Max Balance:</p>
                              <p className='text-genius-cream/40'>
                                {token.formatted_balance?.toFixed(2)}
                              </p>
                              <p>(${token.usd_value?.toFixed(2)})</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
};
export default DTKeypadHeader;